// Fuente de velas (/api/public/candles y /charting/history solo aceptan
// 'bingx' | 'twelve') derivada del símbolo seleccionado.
//
// Regla de catálogo: los listados crypto vienen de BingX y el resto
// (forex, índices, acciones, commodities) de Twelve Data. El response de
// /symbols ya trae `type` por item — sourceForAssetType es la fuente de
// verdad cuando el item está disponible (selección desde el catálogo);
// deriveCandleSource cubre las rutas sin item (favoritos guardados como
// string, símbolo restaurado de localStorage), donde solo hay el texto
// del símbolo.

export function sourceForAssetType(type) {
  return type === 'crypto' ? 'bingx' : 'twelve'
}

// Heurística sobre el string: todos los símbolos crypto que sirven los dos
// catálogos (BingX swap) están marginados en USDT/USDC ('BTC/USDT',
// 'BTC/USDT:USDT'); cualquier par con otra divisa ('EUR/USD', 'XAU/USD'),
// índice ('SPX', '000001') o acción ('AAPL') es Twelve Data.
export function deriveCandleSource(symbol) {
  if (!symbol || typeof symbol !== 'string') return 'bingx'
  return /\/(USDT|USDC)(:|\/|$)/i.test(symbol) ? 'bingx' : 'twelve'
}

// Resuelve la selección de un símbolo: si el catálogo informó la fuente se
// respeta; si no (favoritos, restauración), se deriva del texto. Garantiza
// que cambiar de un símbolo twelve a uno crypto devuelve la fuente a bingx.
export function resolveSelectionSource(symbol, catalogSource) {
  return catalogSource === 'bingx' || catalogSource === 'twelve'
    ? catalogSource
    : deriveCandleSource(symbol)
}
